module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEfSURBVHgBrZPLDYJAFEVnBvfagbiBsKME7UArkBLsQKzAWIHagR2oFagrvomUYAOA95lnQhANY7gJzJvPO3PnJwUrCIKxYRhzoaE8z8+O4+woVvRLkmSplDoiNNtCyrIcIGcbRdGF6pKcMGRm2/ZBaAi5JnIvRVFslJRyyu1rdHgaENqKLcIBGK4ii6hcQT2z1fsvIAHiOD7yKkgHxP3XHoH4wKZ5gI2+AesAjJtYljVBeaN6rzobYBkKD0k+Sp+BS0yUwfkYbScCYNyp7lQ12Sdg1WHVQRPkw1ETkByKFlKiI3UHohPjK/CXcJeGLxAgdJtdeiZCU2mazpHv4c3tJTWEYbiAszXCB39tZeI0VzgUX75b+N246NBZZva+Dk8Nm6QeyekllwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/email_1.png
// module id = 4nR/
// module chunks = 17